import type { AuthSession } from "@features/auth/types/types";

const persistentKey = "orbit-proplist-session";
const temporaryKey = "orbit-proplist-session-temp";

function parse(value: string | null): AuthSession | null {
  if (!value) return null;
  try {
    return JSON.parse(value) as AuthSession;
  } catch {
    return null;
  }
}

export const authStorage = {
  get: () =>
    parse(localStorage.getItem(persistentKey)) ||
    parse(sessionStorage.getItem(temporaryKey)),
  set(session: AuthSession) {
    this.clear();
    const storage = session.rememberMe ? localStorage : sessionStorage;
    storage.setItem(
      session.rememberMe ? persistentKey : temporaryKey,
      JSON.stringify(session),
    );
  },
  clear() {
    localStorage.removeItem(persistentKey);
    sessionStorage.removeItem(temporaryKey);
  },
  accessToken: () => authStorage.get()?.accessToken || null,
};
